// src/passwordUtils.js

const getCharPoolSize = (password) => {
  let pool = 0;
  if (/[a-z]/.test(password)) pool += 26;
  if (/[A-Z]/.test(password)) pool += 26;
  if (/[0-9]/.test(password)) pool += 10;
  if (/[^A-Za-z0-9]/.test(password)) pool += 32;
  return pool || 1;
};

// Formatiert sehr große Zahlen in deutsche Einheiten (Millionen, Milliarden, Billionen, Billiarden, ...)
// und bleibt dabei "genau genug" (1 Nachkommastelle, ab 100 ohne Nachkommastelle).
const formatGermanBigNumber = (num) => {
  if (!Number.isFinite(num) || num <= 0) return "-";

  const units = [
    { value: 1e63, label: "Vigintilliarden" },
    { value: 1e60, label: "Vigintillionen" },
    { value: 1e57, label: "Novemdecilliarden" },
    { value: 1e54, label: "Novemdecillionen" },
    { value: 1e51, label: "Oktodecilliarden" },
    { value: 1e48, label: "Oktodecillionen" },
    { value: 1e45, label: "Septendecilliarden" },
    { value: 1e42, label: "Septendecillionen" },
    { value: 1e39, label: "Sexdecilliarden" },
    { value: 1e36, label: "Sexdecillionen" },
    { value: 1e33, label: "Quindecilliarden" },
    { value: 1e30, label: "Quindecillionen" },
    { value: 1e27, label: "Quattuordecilliarden" },
    { value: 1e24, label: "Quattuordecillionen" },
    { value: 1e21, label: "Tredecilliarden" },
    { value: 1e18, label: "Tredecillionen" },
    { value: 1e15, label: "Billiarden" },
    { value: 1e12, label: "Billionen" },
    { value: 1e9, label: "Milliarden" },
    { value: 1e6, label: "Millionen" },
  ];

  for (const u of units) {
    if (num >= u.value) {
      const v = num / u.value;

      // "genau", aber nicht unlesbar:
      // - ab 100: keine Nachkommastelle
      // - sonst: 1 Nachkommastelle
      const rounded = v >= 100 ? Math.round(v) : Math.round(v * 10) / 10;

      // deutsches Komma
      const text = rounded.toString().replace(".", ",");

      return `ca. ${text} ${u.label}`;
    }
  }

  return Math.round(num).toString();
};

export const calculatePasswordSecurity = (password) => {
  if (!password) {
    return {
      combinations: "-",
      growthFactor: "-",
    };
  }

  const length = password.length;
  const pool = getCharPoolSize(password);

  const combinationsRaw = Math.pow(pool, length);

  // Jede zusätzliche Stelle vervielfacht den Suchraum um ungefähr "pool".
  // Beispiel: wenn pool ~ 94, dann ist +1 Zeichen ~ 94-mal mehr Möglichkeiten.
  const growthFactor = pool;

  return {
    combinations: formatGermanBigNumber(combinationsRaw),
    growthFactor: growthFactor.toString().replace(".", ","),
  };
};

export const checkPasswordStrength = (password) => {
  if (!password) return "Schwach";

  let score = 0;
  if (password.length >= 8) score += 1;
  if (password.length >= 12) score += 1;
  if (/[a-z]/.test(password)) score += 1;
  if (/[A-Z]/.test(password)) score += 1;
  if (/[0-9]/.test(password)) score += 1;
  if (/[^A-Za-z0-9]/.test(password)) score += 1;

  if (score <= 2) return "Schwach";
  if (score <= 4) return "Mittel";
  return "Stark";
};
